module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEPSURBVHgBzZS7agJRFEX3nWgIIU9IkUICIU3SpEiVzqTJH4SkTMgPBNQfEDu/QbQVtbWw0sJHpSCopQ+U0cYHiCiC4xzRy4gKRwfBVd2zOWz2PcUW0Ll15X8UwI4dmACJpvc5IMhECPhhAk3DrwKhvcEsCuwW7u7FiYKPp3M5ZyoD1DtjObOMbNdWBP/uYLuySs0RURHu9AyhGPy/3yyZrIOV6PPlUr59qTZipT6K6nB7IyNkkikPVnTW1zhsTEQ3STofVnQ6OpHWU337ajCdKJLt8RIRi1u83p9KraCO0OiOEcoxjer68tc8etXzKHV3tLXfYx+ikSbiMMsECQuVkt5JNLKK7ez4iPrHyKzYptBvUrXfyhfpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/facebook4.png
// module id = +BRZ
// module chunks = 134